import React from "react";
import { View, Pressable, StyleSheet } from "react-native";
import { Svg, Path } from "react-native-svg";
import { C, RText } from "./theme";

// The mockup's screen header (routing §10, racking §9): back arrow + 19px /
// 600 title on white, 16px padding, no shadow.
const DsHeader = ({ title, navigation, right, testID = "ds-routing-back" }) => (
  <View style={styles.bar}>
    <Pressable testID={testID} hitSlop={12} onPress={() => navigation.goBack()}>
      <Svg width={22} height={22} viewBox="0 0 24 24">
        <Path
          d="M19 12H5"
          fill="none"
          stroke={C.ink}
          strokeWidth={2.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12 19l-7-7 7-7"
          fill="none"
          stroke={C.ink}
          strokeWidth={2.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </Pressable>
    <RText size={19} weight={600} style={styles.title} numberOfLines={1}>
      {title}
    </RText>
    {right || null}
  </View>
);

export default DsHeader;

const styles = StyleSheet.create({
  bar: {
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
    padding: 16,
    backgroundColor: C.surface,
  },
  title: { flex: 1, letterSpacing: -0.2 },
});
